"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks/shared";
import { invalidateUserTaskQueries } from "@/lib/user-tasks/invalidate-user-task-queries";
import { TenantUserTasksApi } from "@/lib/user-tasks/tenant-user-tasks-api";
import { createAuthenticatedApi } from "@/lib/utils";

export function useUserTaskDelete() {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (taskId: string) => {
      if (!accessToken || tenantId == null) {
        throw new Error("Authentication required");
      }
      const service = createAuthenticatedApi(TenantUserTasksApi, accessToken);
      await service.apiUserTasksIdDelete({
        id: taskId,
        xTenantID: tenantId,
      });
    },
    onSuccess: async () => {
      await invalidateUserTaskQueries(queryClient, tenantId);
    },
  });

  return {
    deleteTask: mutation.mutate,
    deleteTaskAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
}
